import React, { useMemo } from 'react';
import DataGrid from '../../common/DataGrid';

const currencyFormatter = (params) => {
  if (params.value == null) return '';
  return params.value.toFixed(2);
};

const dateFormatter = (params) => {
  if (!params.value) return '';
  return new Date(params.value).toLocaleDateString();
};

const toLocalMidnight = (dateValue) => {
  if (!dateValue) return null;
  return new Date(`${String(dateValue).substring(0, 10)}T00:00:00`);
};

const StatusRenderer = (params) => {
  const { due_date, is_sent, is_accepted } = params.data ?? {};
  let status = 'Draft';
  let colorClass = 'text-blue-500 bg-blue-50';

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expiry = toLocalMidnight(due_date);

  if (is_accepted) {
    status = 'Accepted';
    colorClass = 'text-emerald-600 bg-emerald-50';
  } else if (is_sent && expiry && expiry < today) {
    status = 'Expired';
    colorClass = 'text-red-500 bg-red-50';
  } else if (is_sent) {
    status = 'Sent';
    colorClass = 'text-amber-600 bg-amber-50';
  } else if (expiry && expiry < today) {
    status = 'Expired';
    colorClass = 'text-red-500 bg-red-50';
  }

  return (
    <div className="flex items-center h-full">
      <span className={`px-2 py-0.5 rounded-xl text-xs font-semibold flex items-center gap-1 ${colorClass}`}>
        {status}
      </span>
    </div>
  );
};

export default function QuoteGrid(props) {
  const columns = useMemo(
    () => [
      { field: 'quotation_number', headerName: 'Quote No.', maxWidth: 150 },
      {
        headerName: 'Customer',
        maxWidth: 200,
        flex: 2,
        valueGetter: (params) =>
          params.data.customers?.full_name || params.data.customer_name || 'Unknown',
      },
      { field: 'quotation_date', headerName: 'Date', maxWidth: 130, valueFormatter: dateFormatter },
      { field: 'due_date', headerName: 'Expiry Date', maxWidth: 130, valueFormatter: dateFormatter },
      { field: 'total_amount', headerName: 'Amount', valueFormatter: currencyFormatter, maxWidth: 150, type: 'rightAligned' },
      { headerName: 'Status', cellRenderer: StatusRenderer, minWidth: 120 },
    ],
    []
  );

  return (
    <DataGrid
      {...props}
      columns={columns}
      exportFileName="quotes.csv"
      editLabel="View/Edit"
      pagination
      paginationSize={20}
    />
  );
}
